import { atom } from 'jotai';

export const fcmAtom = atom<string | undefined>();
